import uuid from 'uuid'
import { IFile, IFileObject } from '../types'

/**
 * Maps the values from MUI-Dropzone into the format that Fleet Planner expects for file upload.
 */
export const mapDropzoneFiles = (files: IFileObject[] = []): IFile[] => {
  return files.map(f => {
    const { data, file } = f || {}
    const { name } = file || {}
    return { file: data as string, fileFileName: name, uuid: uuid() }
  })
}
